const SettingsFormReducer = (state, action) => {
    switch (action.type) {
        case 'SET_INPUT':
            return {
                ...state,
                [action.field]: action.payload,
            };

        case 'SET_ALL_FIELDS':
            return action.payload;

        default:
            return state;
    }
};

export default SettingsFormReducer;
